import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'
import { DrrHttpClient } from '../../http/drr-http-client'
import { TowServiceAvailabilitySchema } from './tow-service-availability.model'
import {
  TowServiceAvailability,
  TowServiceAvailabilityParams,
} from './tow-service-availability.types'

@Injectable({
  providedIn: 'root',
})
export class TowServiceAvailabilityService {
  constructor(private httpClient: DrrHttpClient) {}

  getTowServiceAvailability$(
    params: TowServiceAvailabilityParams
  ): Observable<TowServiceAvailability> {
    return this.httpClient
      .get<TowServiceAvailability>(
        `/bff/club/${params.clubCode}/tow-service-availability`,
        {
          params: {
            locationCode: params.locationCode,
            breakdownLatitude: String(params.breakdownLatitude),
            breakdownLongitude: String(params.breakdownLongitude),
            towDestinationLatitude: String(params.towDestinationLatitude),
            towDestinationLongitude: String(params.towDestinationLongitude),
          },
        }
      )
      .pipe(tap((response) => TowServiceAvailabilitySchema.validateSync(response)))
  }
}
